export const localeFallbacks = {"de":"de-AT","de-AT":"de","en":"de"};
